import React from "react";
import MainContent from "../../../../../widgets/templates/main_content";
import InfoForms from "./info";

function ActiveFormsPage(){

    return(
        <MainContent>
            <div className="flex-row" style={{ marginTop: '15px' }}>
                <div style={{ width: '100%' }}>
                    <span className="vp-title">Planillas activas</span>
                </div>
            </div>
            <hr />
            <InfoForms 
            
            />
        </MainContent>
    );
}

export default ActiveFormsPage;